import { render, staticRenderFns } from "./RolePermissionList.vue?vue&type=template&id=6e071a8f"
import script from "./RolePermissionList.vue?vue&type=script&lang=ts"
export * from "./RolePermissionList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports